import { render, staticRenderFns } from "./OzMembershipTierGrid.vue?vue&type=template&id=3c7f697e&scoped=true&"
import script from "./OzMembershipTierGrid.vue?vue&type=script&lang=ts&"
export * from "./OzMembershipTierGrid.vue?vue&type=script&lang=ts&"
import style0 from "./OzMembershipTierGrid.vue?vue&type=style&index=0&id=3c7f697e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7f697e",
  null
  
)

export default component.exports